<template>
  <BaseAutocomplete
    :label="label"
    :placeholder="placeholder"
    :items="questionTypes"
    v-model="level"
    item-text="value"
    item-value="value"
    hide-details
    :clearable="isClearable"
    :returnObject="false"
  />
</template>
<script>
export default {
  props: {
    label: String,
    placeholder: String,
    itemText: String,
    itemValue: String,
    multiple: Boolean,
    isClearable: Boolean,
  },
  data() {
    return {
      level: null,
    }
  },
  computed: {
    questionTypes() {
      return [
        {title: '', value: 1},
        {title: '', value: 2},
        {title: '', value: 3},
        {title: '', value: 4},
      ]
    },
  },
  watch: {
    level: {
      handler(val) {
        this.$emit('input', val)
      },
      immediate: true,
    },
  },
}
</script>
